import { render, staticRenderFns } from "./StoreDeliveryView.vue?vue&type=template&id=71f7c6f0&lang=pug"
import script from "./StoreDeliveryView.vue?vue&type=script&lang=js"
export * from "./StoreDeliveryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports